
(()=>{if(window.ld2FounderMotion)return;window.ld2FounderMotion=true;
 const reduced=matchMedia('(prefers-reduced-motion: reduce)'), mobile=matchMedia('(max-width: 749px)'), cleanups=new Map();
 function mount(section){
  cleanups.get(section)?.();
  const undo=[]; cleanups.set(section,()=>undo.forEach(fn=>fn()));
  if(reduced.matches||!window.Motion)return;
  const enabled=section.dataset.ld2Motion==='true'&&(!mobile.matches||section.dataset.motionMobile==='true');
  const distance=Number(section.dataset.motionStrength||0)*(mobile.matches?.25:1);
  function drift(selector,factor,background=false){
   if(!enabled||!distance)return;
   section.querySelectorAll(selector).forEach(el=>{
    const base=getComputedStyle(el).transform==='none'?'':getComputedStyle(el).transform;
    const travel=distance*factor; const originalTransform=el.style.transform;
    // translate composes with existing rotated Polaroids without replacing their transform.
    if(background){el.style.scale='1.2';undo.push(()=>el.style.removeProperty('scale'));}
    const animation=Motion.animate(el,{transform:[`translateY(${-travel}px) ${base}`,`translateY(${travel}px) ${base}`]},{easing:'linear'});
    const stop=Motion.scroll(animation,{target:section,offset:Motion.ScrollOffset.Any});
    el.dataset.motionLayer='true';
    undo.push(()=>{stop();animation.cancel();el.style.transform=originalTransform;delete el.dataset.motionLayer;});
   });
  }
  drift(':scope.ld2-hero > .ld2-media > img, :scope.ld2-hero > .ld2-media > video',.8,true);
  drift(':scope.ld2-banner > .ld2-media > img, :scope.ld2-banner > .ld2-media > video',.8,true);
  drift('.ld2-art > .ld2-polaroid, .ld2-story-art > .ld2-polaroid',-.45);
  drift('.ld2-cutout',.8);drift('.ld2-stack',-.7);drift('.ld2-film',.8);
  drift('.ld2-detail-grid > article:nth-child(odd)',-.35);drift('.ld2-detail-grid > article:nth-child(even)',.35);
  drift('.ld2-newsletter-art',-.35);
  drift('.ld2-tile:nth-child(odd) .ld2-tile-photo',-.2);drift('.ld2-tile:nth-child(even) .ld2-tile-photo',.2);
  drift(':scope.ld2-strip a:nth-child(odd)',-.12);drift(':scope.ld2-strip a:nth-child(even)',.12);
  if(section.dataset.motionReveal==='true'){
   const targets=[...section.querySelectorAll('.ld2-tile, .ld2-story-copy, .ld2-details-title, .ld2-newsletter .ld2-two > div:last-child, :scope > .ld2-wrap > h2')];
   const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(!entry.isIntersecting)return;
    const el=entry.target;observer.unobserve(el);
    const animation=Motion.animate(el,{opacity:[.35,1],scale:[.96,1]},{duration:.65,delay:Math.min(targets.indexOf(el)%6*.075,.3),easing:'ease-out'});
    undo.push(()=>animation.cancel());
   }),{threshold:.12});
   targets.forEach(el=>observer.observe(el));undo.push(()=>observer.disconnect());
  }
 }
 function init(){document.querySelectorAll('.ld2-founder[data-ld2-motion]').forEach(mount);}
 if(document.readyState==='complete')init();else window.addEventListener('load',init,{once:true});
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.ld2-founder[data-ld2-motion]').forEach(mount));
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.ld2-founder[data-ld2-motion]').forEach(el=>{cleanups.get(el)?.();cleanups.delete(el);}));
 reduced.addEventListener('change',init);mobile.addEventListener('change',init);
})();
